<template>
	<section class="app-container">

		<div class="h1-buttons">
			<h1>Test Run Dashboard</h1>
			<div>
				<button class="btn btn-secondary" @click="filterExpanded = !filterExpanded">Filter</button>
				<button class="btn btn-primary" @click="runTests()">Run Tests</button>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<TestRunnerDashboardSummary v-if="runId" :runId="runId" />
				<NoData v-else />
			</div>
			<div v-show="filterExpanded" class="col-4">
				<button type="button" @click="filterExpanded=false" class="btn btn-compact btn-primary">X</button>
				<TestRunnerDashboardSearch :selectedTestRun="runId" @selectTestRun="selectTestRun"/>
			</div>
		</div>
	</section>
</template>

<script>
import NoData from '../shared/NoData';
import TestRunnerDashboardSummary from './TestRunnerDashboardSummary';
import TestRunnerDashboardSearch from './TestRunnerDashboardSearch';

export default {
	name: 'TestRunnerDashboard',
	props: [],
	components: {
		NoData,
		TestRunnerDashboardSummary,
		TestRunnerDashboardSearch
	},
	data: function() {
		
		return {
			filterExpanded: false,
			runId: null
		};
	},
	methods: {
		runTests() {
			this.$router.push({ name: 'RunTests' });
		},
		selectTestRun(runId){
			this.runId = runId;
		}
	}
};
</script>

<style scoped>
</style>
